import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';
import RouterApp from '../src/components/pages/routerApp/routerApp.js';
import { BrowserRouter as Router } from 'react-router-dom';
// import { Route } from "react-router";
import registerServiceWorker from './registerServiceWorker';
import Complete from '../src/components/pages/complete.js';
import 'antd/dist/antd.css';
// import './style.css';
const client = new ApolloClient({
    link: new HttpLink({ uri: process.env.REACT_APP_API_URI }),
    cache: new InMemoryCache(),
  });


ReactDOM.render(
    <ApolloProvider client={client}>
    <Router>
        <RouterApp component={Complete} />
    </Router>
</ApolloProvider>
    , document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js